import { render, staticRenderFns } from "./mdCaption.vue?vue&type=template&id=55999f30&scoped=true&"
import script from "./mdCaption.vue?vue&type=script&lang=js&"
export * from "./mdCaption.vue?vue&type=script&lang=js&"
import style0 from "./mdCaption.vue?vue&type=style&index=0&id=55999f30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55999f30",
  null
  
)

export default component.exports